import ReactSelect from "react-select";
import { fetchApi, ReactSelectComponents, toSelect } from "@/helpers/h";
import { components } from "react-select";
import { cx } from "class-variance-authority";
import { useEffect, useState } from "react";
import { Input } from "./input";
import toast from "react-hot-toast";
import { useOutsideClick } from "@/hooks/useClickOutside";
import { useFetch } from "@/hooks/useFetch";

export const Select = ({ className, ...props }) => {
  const Control = (props) => {
    let cxClass;
    if (props.menuIsOpen) {
      cxClass = "!outline-none !ring-2 !ring-blue-500 !border-transparent";
    } else {
      cxClass = "!ring-0";
    }
    if (props.isDisabled) {
      cxClass += " !bg-gray-100";
    }
    return (
      <components.Control
        {...props}
        className={cx(
          "border !border-gray-400",
          "!min-h-[49px] min-w-[200px]",
          "!rounded-md",
          "px-2",
          cxClass,
          className,
        )}
      />
    );
  };

  return (
    <ReactSelect
      {...props}
      components={{
        ...ReactSelectComponents,
        Control: Control,
      }}
    />
  );
};

export const SelectGroup = ({
  label,
  className = "",
  direction = "vertical",
  ...props
}) => {
  return (
    <div
      className={cx(
        "grid",
        direction === "horizontal"
          ? "grid-cols-1 md:grid-cols-3 gap-3"
          : "grid-cols-1 gap-3",
      )}
    >
      {label && (
        <span className="font-bold text-[16px] capitalize mt-3">{label}</span>
      )}
      <div className="col-span-1 md:col-span-2 flex flex-col">
        <Select {...props} className={className} />
      </div>
    </div>
  );
};

export const SelectServer = ({
  value,
  onChange,
  minLetters = 3,
  label,
  url,
  direction = "vertical",
  optionValuekey = "id",
  optionLabelKey = "name",
}) => {
  const [type, setType] = useState();
  const [options, setOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const inputRef = useOutsideClick(() => {
    setIsOpen(false);
    setType("");
  });
  useEffect(() => {
    const timeOut = setTimeout(async () => {
      if (type?.length >= minLetters && isOpen) {
        const res = await fetchApi({
          url: `${url}?search=${type}`,
          method: "GET",
        });
        setIsLoading(false);
        if (!res.data.success) {
          toast.error(res.data.message);
        } else {
          setOptions(toSelect(res.data.data, optionValuekey, optionLabelKey));
        }
      } else {
        setIsOpen(false);
      }
    }, 500);
    return () => {
      clearTimeout(timeOut);
    };
  }, [type]);
  const { data: detailData } = useFetch({
    url: `${url}/${value}`,
    dep: [value],
    condition: value ? true : false,
  });
  return (
    <div
      className={cx(
        "grid",
        direction === "horizontal"
          ? "grid-cols-1 md:grid-cols-3 gap-3"
          : "grid-cols-1 gap-3",
      )}
    >
      {label && (
        <span className="font-bold text-[16px] capitalize mt-3">{label}</span>
      )}
      <div className="col-span-1 md:col-span-2 flex flex-col">
        <div className="relative w-full" ref={inputRef}>
          <Input
            className="w-full"
            placeholder={`Type at least ${minLetters} letters`}
            value={type || ""}
            onChange={(e) => {
              if (e.target.value?.length >= minLetters) {
                setIsLoading(true);
                setIsOpen(true);
              }
              setType(e.target.value);
            }}
            onFocus={() => {
              setType("");
            }}
          />
          <div className="font-semibold mt-2">
            value: {detailData ? detailData[optionLabelKey] : ""}
          </div>
          {isOpen && (
            <div className="absolute w-full bg-white shadow-md mt-1 z-50">
              <ul
                className={cx(
                  "rounded-md border border-gray-400",
                  "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
                  "transition duration-300 ease-in-out disabled:bg-gray-100",
                  "flex flex-col gap-1",
                  "max-h-[300px] overflow-y-auto",
                )}
              >
                {!isLoading ? (
                  <>
                    {options?.length > 0 ? (
                      <>
                        {options.map((item, index) => (
                          <li
                            key={index}
                            className="cursor-pointer p-2 hover:bg-gray-100"
                            onClick={() => {
                              onChange({
                                value: item.value,
                                label: item.label,
                              });
                              setIsOpen(false);
                              setType(item.label);
                            }}
                          >
                            {item.label}
                          </li>
                        ))}
                      </>
                    ) : (
                      <li className="p-2">No data found</li>
                    )}
                  </>
                ) : (
                  <li className="p-2">Loading...</li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
